module.exports = __webpack_public_path__ + "img/ZZRY_12.79f67b73.jpg";